import { MULTI_SOURCE_TYPE_IDS } from "./SignalWizard.constants";
import { STEPS } from "./SignalWizard.types";

export const getStepLabel = (step, language) =>
    language?.tracker_wizard?.[STEPS[step]?.languageKey] ?? STEPS[step]?.label;

/** Accepts a single id or a list of ids and returns numeric ids. */
export const normalizeIds = (idOrIds) =>
    (Array.isArray(idOrIds) ? idOrIds : [idOrIds])
        .filter((id) => id != null && id !== "")
        .map(Number);

/**
 * Only one source per source type can be part of a tracker, except for the
 * types listed in `MULTI_SOURCE_TYPE_IDS`.
 */
export const toggleSourceSelection = (selectedSources, source, checked) => {
    const sourceTypeId = source.source_type_id;
    const next = { ...selectedSources };

    if (!MULTI_SOURCE_TYPE_IDS.includes(sourceTypeId)) {
        Object.entries(next)
            .filter(([, typeId]) => typeId === sourceTypeId)
            .forEach(([id]) => delete next[id]);
    }

    if (checked) {
        next[source.id] = sourceTypeId;
    } else {
        delete next[source.id];
    }
    return next;
};

export const isSourceSelected = (selectedSources, source) =>
    selectedSources[source.id] === source.source_type_id;

export const getSelectedSourceIds = (selectedSources) =>
    Object.keys(selectedSources).filter((id) => id !== "undefined");

export const filterBySearch = (items, query, typeKey) => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return items;
    return items.filter((item) =>
        [item?.name, item?.[typeKey]?.name].some((value) =>
            value?.toLowerCase().includes(normalizedQuery),
        ),
    );
};

export const filterByType = (items, typeCode, typeKey) =>
    typeCode
        ? items.filter((item) => item?.[typeKey]?.code === typeCode)
        : items;

/** Unique `{ code, name, count }` entries of the types present in `items`. */
export const getTypeOptions = (items, typeKey) => {
    const options = new Map();
    items.forEach((item) => {
        const type = item?.[typeKey];
        if (!type?.code) return;
        const option = options.get(type.code);
        options.set(type.code, {
            code: type.code,
            name: type.name ?? type.code,
            count: (option?.count ?? 0) + 1,
        });
    });
    return [...options.values()].sort((a, b) => a.name.localeCompare(b.name));
};

export const isDeletable = (item) => !item?.trackers?.length;

export const buildTrackerPayload = ({
    selectedSources,
    selectedDestinations,
    trackerName,
}) => ({
    sources: getSelectedSourceIds(selectedSources),
    destinations: selectedDestinations,
    tracker_name: trackerName.trim(),
});
